export default "__VITE_ASSET__Dbf5D0vc__"